export default "__VITE_ASSET__Ab4Pq8uB__"